// extracted by mini-css-extract-plugin
export default {"form":"LoginPass_form__rLVmi","submit":"LoginPass_submit__g8Szk","back":"LoginPass_back__yQ1F+","placeHolderShimmer":"LoginPass_placeHolderShimmer__pqko2"};